import { useFeaturedReviews } from '../../hooks/useFeaturedReviews';
import { useDragScroll } from '../../hooks/useDragScroll';
import { StarRating } from '../ui/StarRating';
import { StoreFeaturedReview } from '../../models';

function ReviewCard({ review }: { review: StoreFeaturedReview }) {
  return (
    <div className="w-72 sm:w-80 shrink-0 bg-white rounded-2xl border border-champagne-dark shadow-sm p-5 flex flex-col">
      <StarRating value={review.rating} size="sm" />
      <p className="text-sm text-text-medium leading-relaxed mt-3 flex-1">&ldquo;{review.comment}&rdquo;</p>
      <div className="mt-4 pt-3 border-t border-champagne">
        <p className="text-sm font-semibold text-text-dark">
          {review.reviewerFirstName}
          {review.reviewerCity && <span className="text-text-light font-normal"> — {review.reviewerCity}</span>}
        </p>
        {review.productName && (
          <span className="inline-block mt-1.5 text-[11px] font-medium text-chocolate-dark bg-champagne px-2 py-0.5 rounded-full">
            {review.productName}
          </span>
        )}
      </div>
    </div>
  );
}

export function SocialProof() {
  const { reviews, isLoading, error, isEmpty } = useFeaturedReviews();
  const {
    ref: scrollRef,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
    onMouseEnter,
    onTouchStart,
    onTouchEnd,
    onClickCapture,
  } = useDragScroll<HTMLDivElement>();

  if (isLoading || error || isEmpty) return null;

  return (
    <div className="max-w-[1600px] mx-auto px-4 pt-10">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-chocolate-dark mb-1">
        O que nossas clientes dizem
      </p>
      <div className="w-9 h-0.5 bg-chocolate mt-3 mb-6" />

      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto no-scrollbar pb-2 pr-4 cursor-grab select-none [scroll-behavior:auto]"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onClickCapture={onClickCapture}
      >
        {reviews.map((review) => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </div>
    </div>
  );
}
